import React, { useState } from 'react';
import { ROUTES } from 'src/constants/routes.const';
import { PlatformPage } from 'src/utils/analytics/analytics.const';
import { UpsellBannerContainer } from 'src/apps/Payment/UpsellBanner';
import { useScenariosBetaStatus } from 'src/apps/Classic/useScenariosBetaStatus';
import { MigrationBanner } from 'src/apps/Classic/MigrationBanner';
import { defineMessages, useIntl } from 'react-intl';
import DashboardFrame from '../DashboardFrame';
import { Overview } from './Overview';

const msgs = defineMessages({
  title: { id: 'tabbar_label_home' },
});

const Home = () => {
  const intl = useIntl();
  const [country, setCountry] = useState<string | undefined>(undefined);
  const { isJoined } = useScenariosBetaStatus();

  /* istanbul ignore next: temporary code, tested manually */
  if (isJoined === false) {
    return <MigrationBanner />;
  }

  return (
    <DashboardFrame
      sidebarUrl={ROUTES.dashboard}
      setCountry={setCountry}
      pageScreenName={PlatformPage.HOME}
      pageTitle={intl.formatMessage(msgs.title)}
    >
      <UpsellBannerContainer isHomeTab country={country} />
      <Overview />
    </DashboardFrame>
  );
};

export default Home;
